import { defineComponent as y, watch as I, createElementBlock as m, openBlock as i, mergeProps as h, unref as o, createElementVNode as a, normalizeClass as t, renderSlot as p, createBlock as d, resolveDynamicComponent as f, createCommentVNode as P, withCtx as u, createVNode as T, createTextVNode as k, toDisplayString as w } from "vue";
import r from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/ProgressStepper/progress-stepper.js";
import B from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Button/button.js";
import { useOUIAProps as E } from "../../helpers/ouia.js";
import { CircleCheckIcon as N } from "../../packages/icons/dist/esm/icons/circle-check-icon.js";
import { ResourcesFullIcon as V } from "../../packages/icons/dist/esm/icons/resources-full-icon.js";
import { TriangleExclamationIcon as $ } from "../../packages/icons/dist/esm/icons/triangle-exclamation-icon.js";
import { CircleExclamationIcon as D } from "../../packages/icons/dist/esm/icons/circle-exclamation-icon.js";
import v from "../../helpers/PassThrough.vue2.js";
import { useHtmlElementFromVNodes as L } from "../../use/index.js";
import { vnodeTypeIsComponent as b } from "../../util.js";
const F = ["aria-current"], R = {
  default: void 0,
  pending: void 0,
  success: N,
  info: V,
  warning: $,
  danger: D
}, z = {
  default: "",
  info: r.modifiers.info,
  success: r.modifiers.success,
  pending: r.modifiers.pending,
  warning: r.modifiers.warning,
  danger: r.modifiers.danger
}, W = /* @__PURE__ */ y({
  name: "PfProgressStep",
  __name: "ProgressStep",
  props: {
    variant: {},
    current: { type: Boolean },
    description: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(S) {
    const l = S, g = E({ id: l.ouiaId, safe: l.ouiaSafe }), { element: s, findReference: C } = L((e) => b(e.type) && e.type.name === "PfPopover");
    return I(s, () => {
      var e, n, c;
      (e = s.value) == null || e.classList.add(r.progressStepperStepTitle), (n = s.value) == null || n.classList.add(r.modifiers.helpText), (c = s.value) == null || c.classList.remove(B.button);
    }), (e, n) => (i(), m("li", h(o(g), {
      class: [o(r).progressStepperStep, e.variant ? z[e.variant] : void 0, {
        [o(r).modifiers.current]: e.current
      }],
      role: "listitem",
      "aria-current": e.current ? "step" : void 0
    }), [
      a("div", {
        class: t(o(r).progressStepperStepConnector)
      }, [
        a("span", {
          class: t(o(r).progressStepperStepIcon)
        }, [
          p(e.$slots, "icon", {}, () => [
            (i(), d(f(e.variant ? R[e.variant] : void 0)))
          ])
        ], 2)
      ], 2),
      a("div", {
        class: t(o(r).progressStepperStepMain)
      }, [
        (i(), d(f(o(s) ? v : "div"), {
          class: t(o(r).progressStepperStepTitle)
        }, {
          default: u(() => [
            T(v, { onChildren: o(C) }, {
              default: u(() => [
                p(e.$slots, "default")
              ]),
              _: 3
            }, 8, ["onChildren"])
          ]),
          _: 3
        }, 8, ["class"])),
        e.description || e.$slots.description ? (i(), m("div", {
          key: 0,
          class: t(o(r).progressStepperStepDescription)
        }, [
          p(e.$slots, "description", {}, () => [
            k(w(e.description), 1)
          ])
        ], 2)) : P("", !0)
      ], 2)
    ], 16, F));
  }
});
export {
  W as default
};
